import type { FC } from "react";

import classnames from "classnames";

import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";

import styles from "./Logo.module.scss";

export type LogoProps = {
  isDarkMode: boolean;
  link: string;
  srcDark?: string;
  srcLight?: string;
  title: string;
  width?: number;
  height?: number;
  alt: string;
  className?: string;
  renderImage?: (props: {
    src: string;
    alt: string;
    title?: string;
    className?: string;
    width?: number;
    height?: number;
  }) => React.ReactNode;
};

export const Logo: FC<LogoProps> = ({
  isDarkMode = false,
  link,
  srcDark,
  srcLight,
  title,
  alt,
  width,
  height,
  className,
  renderImage,
}) => {
  const src = (isDarkMode ? srcLight : srcDark) ?? "";

  const ImageComponent = renderImage ? (
    renderImage({ src, alt, title, className: styles.image, width, height })
  ) : (
    <ImageBehaviour src={src} alt={alt} title={title} className={styles.image} width={width} height={height} />
  );

  return (
    <div className={classnames(styles.logo, className)} style={{ width, height }} data-testid="brandLogo">
      <LinkBehaviour href={link}>{ImageComponent}</LinkBehaviour>
    </div>
  );
};
